<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="人员管理"
    >
      <li
        v-if="state.select_count > 0"
        class="text-sm text-gray-400 flex items-center"
      >
        已选
        <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
        条数据
        <el-button type="danger" link @click="onClearSelect"> 清空 </el-button>
      </li>
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <div class="flex items-center">
        <el-button
          type="primary"
          icon="Plus"
          @click="
            delete state.selectId;
            state.showInfo = true;
          "
        >
          新建
        </el-button>
        <el-button
          type="primary"
          icon="DocumentChecked"
          @click="state.showImport = true"
        >
          Excel导入
        </el-button>
      </div>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        ref="tableDom"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="姓名" label2="性别/类型" />
          </template>
          <template #default="{ row }">
            <div class="flex items-center gap-x-1">
              <c_Avatar
                v-if="row.id"
                :file_url="row.avatar_attachment?.file_url"
                :size="10"
                :title="row.name?.slice(0, 1)"
              />
              <div class="h-10">
                <ul class="flex items-center gap-x-1">
                  <strong
                    class="text-green-700 cursor-pointer hover:underline"
                    @click.stop="
                      state.selectItem = row;
                      state.showDetail = true;
                    "
                  >
                    {{ row.name }}
                  </strong>
                  <c_sex :value="row.sex" v-if="row.id" />
                  <text class="text-gray-400 text-xs">
                    {{ row.d_conferee_type_name }}
                  </text>
                </ul>
                <ul class="text-xs text-gray-400">
                  {{
                    row.pinyin
                  }}
                </ul>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="标签"
          :formatter="$tab_TextFormat"
          :min-width="160"
        >
          <template #default="{ row }">
            <div class="flex flex-wrap gap-2">
              <el-tag
                type="info"
                size="small"
                v-for="item in row.d_conferee_tag_json_arr"
                :key="item"
              >
                {{ item }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="联系电话"
              label2="邮箱/地址"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.email" :value2="row.address">
              <template #top>
                <text>{{ row.phone }}</text>
                <text class="text-gray-400 text-xs ml-4">{{ row.email }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="单位信息" label2="职位" />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.company" :value2="row.job" />
          </template>
        </el-table-column>
        <el-table-column label="参会次数" align="center">
          <template #default="{ row }">
            <strong
              class="text-green-700 cursor-pointer hover:underline"
              @click.stop="
                $openMenu({
                  path: 'HuiYiDetailRiChengDetail',
                  title: '日程详情-' + row.number,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              {{ row.attend_count }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectItem = row;
                state.showDetail = true;
              "
              >查看
            </el-button>
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click.stop="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click.stop="onDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑人员' : '新建人员'"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    destroy-on-close
  >
    <c_info
      :meeting_id="props.meeting_id"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showDetail"
    :title="'人员详情-' + state.selectItem?.name"
    class="c-el-dialog h-full"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 70%"
  >
    <c_detail :id="state.selectItem.id" @close="state.showDetail = false" />
  </el-dialog>
  <el-dialog
    v-model="state.showImport"
    title="从Excel导入"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showImport = false;
      }
    "
    :width="500"
  >
    <c_import
      :meeting_id="props.meeting_id"
      @close="
        state.showImport = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { conferee_page, conferee_delete } from "@/http/conferee";
import { onDeleteConfirm } from "@/utils/funcs";

import c_info from "./Info.vue";
import c_detail from "./Detail.vue";
import c_import from "./Import.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_info,
    c_detail,
    c_import,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      conferee_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(conferee_delete, row.id, onLoad, {
        filed: "人员",
        name: row.name,
      });
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onDelete,
    };
  },
};
</script>

<style lang="scss" scoped></style>
